export default {
  title: "Transcripciones del agente de voz",
  description:
    "Conversaciones del kiosco para revisión de producto. No se guarda identidad de dispositivo ni de huésped.",
  empty: "Aún no hay transcripciones.",
  loadError: "No se pudieron cargar las transcripciones",
  detailLoadError: "No se pudo cargar esta transcripción",
  selectPrompt: "Selecciona una conversación para leerla.",
  endedWith: {
    user_stop: "Finalizada por el huésped",
    error: "Error",
    time_limit: "Límite de tiempo",
  },
  meta: {
    language: "Idioma",
    duration: "Duración",
    turns: "Turnos",
    activities: "Actividades recomendadas",
    none: "Ninguna",
  },
  roles: {
    user: "Huésped",
    assistant: "Agente",
    recommendations: "Recomendadas",
  },
} as const;
